<template>
	<section
		class="flex flex-col space-y-6"
		:class="stacked ? '' : 'md:space-y-0 md:space-x-6 md:flex-row'"
	>
		<ProfileHighlight
			:title="getAdditionalInfoSectionTitle('key_strengths')"
			:items="profileHighlights.keyStrengths"
			:embedded="embedded"
		/>

		<ProfileHighlight
			:title="getAdditionalInfoSectionTitle('work_style')"
			:items="profileHighlights.workStyle"
			:embedded="embedded"
		/>
	</section>
</template>

<script>
import personalityResults from '~/mixins/personalityResults'
import ProfileHighlight from './ProfileHighlight.vue'

export default {
	name: 'OverviewProfileHighlights',
	components: {
		ProfileHighlight
	},
	computed: {
		profileHighlights() {
			const role = this.userIsApplicant ? 'applicant' : 'hiring_manager'
			const insights = this.profileByRole?.[role]?.insights || {}

			return {
				keyStrengths: insights.keyStrengths || [],
				workStyle: insights.workStyle || []
			}
		}
	},
	props: {
		jobOfferData: {
			type: Object,
			default: () => {}
		},
		applicantData: {
			type: Object,
			default: () => {}
		},
		wheelMode: {
			type: String,
			required: true
		},
		stacked: {
			type: Boolean,
			default: false
		},
		embedded: {
			type: Boolean,
			default: false
		}
	},
	mixins: [personalityResults],
	methods: {
		getAdditionalInfoSectionTitle(sectionName) {
			let role = ''

			if (this.userIsApplicant) {
				role = 'applicant'
			} else {
				role = 'hiring_manager'
			}

			return `personality_results.view.${role}.section.${sectionName}`
		}
	}
}
</script>
